// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"20":"1196c007","51":"e39490d3","256":"52cdca9e","273":"3fdbef62","309":"a87f0ed8","416":"0a3a6b8b","519":"db0eb70c","617":"86aa7003","673":"fb5a10e7","728":"7d684a04","949":"bd128467","951":"adf58842","993":"081288ad"}[chunkId] + ".chunk.js";
};